import Vue from 'vue'

Vue.directive('real-img', async function (el, binding) { // 指令名称为：real-img
  const imgURL = binding.value// 获取图片地址
  if (imgURL) {
    const exist = await imageIsExist(imgURL)
    if (exist) {
      el.setAttribute('src', imgURL)
    }
  }
})

/**
 * 检测图片是否存在
 * @param url
 */
const imageIsExist = function (url) {
  return new Promise((resolve) => {
    var img = new Image()
    img.onload = function () {
      if (this.complete == true) {
        resolve(true)
        img = null
      }
    }
    img.onerror = function () {
      resolve(false)
      img = null
    }
    img.src = url
  })
}

Vue.directive('imgPreview', {
  inserted (el, binding, vnode) {
    console.log(el, binding, vnode)
    el.addEventListener('click', function (e) {
      e.stopPropagation()
      const imgSrc = el.getAttribute('src') // 获取当前的图片链接
      let _showImg_ = document.getElementById('__showImg__')
      if (_showImg_) {
        _showImg_.style.display = 'flex'
        const childImg = _showImg_.childNodes[0]
        childImg.setAttribute('src', imgSrc)
      } else {
        _showImg_ = document.createElement('div')
        const body = document.body
        _showImg_.innerHTML = `<img src="${imgSrc}" style="max-width: 100%;" />`
        _showImg_.setAttribute('id', '__showImg__')
        _showImg_.setAttribute('style', 'display: flex;justify-content: center;align-items:center;position:fixed;z-index:9999;left:0;top:0;right:0;bottom:0;background:rgba(0,0,0,0.7);')
        body.appendChild(_showImg_)

        _showImg_.addEventListener('click', function (e) {
          e.stopPropagation()
          this.style.display = 'none'
        })
      }
    })
  }
})
